import { uiActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [uiActions.saveScroll]: (state, action) => {
        var s = {
            id: action.payload.id,
            pos: action.payload.pos
        }
        state[s.id] = s;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        return { ...state, ...action.payload.ui.scrollPos };
    },

})